import { gql } from '@apollo/client';

export const MEDCALL_SEARCH_DIVERSION_PARTICIPANTS = gql`
  query MedcallSearchDiversionParticipants(
    $preserveLegacyResultSemantics: Boolean
    $programKey: String!
    $searchText: String!
  ) {
    medcallSearchDiversionParticipants(
      preserveLegacyResultSemantics: $preserveLegacyResultSemantics
      programKey: $programKey
      searchText: $searchText
    ) {
      cid
      dob
      firstname
      fullname
      in_use
      lastname
      odrparticipant
      participant
      provider
      username
    }
  }
`;

export const buildMedcallIntakeSearchVariables = ({
  programKey,
  routeBase,
  searchText,
}: {
  programKey: string;
  routeBase: string;
  searchText: string;
}) => ({
  preserveLegacyResultSemantics: routeBase === '/tools/medcall2',
  programKey,
  searchText,
});
